"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _jsxRuntime = require("@emotion/react/jsx-runtime");

var _base = _interopRequireDefault(require("@emotion/styled/base"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _WithGlobalNav = _interopRequireDefault(require("./WithGlobalNav.provider"));

var _WithGlobalNav2 = require("./WithGlobalNav.styles");

var LeftSidebarContainer = ( /*#__PURE__*/0, _base["default"])('div', {
  target: "e13cc6bd1",
  label: "LeftSidebarContainer"
})(_WithGlobalNav2.styles.leftSidebarContainer, ";");
var ChildrenContainer = ( /*#__PURE__*/0, _base["default"])('div', {
  target: "e13cc6bd0",
  label: "ChildrenContainer"
})(_WithGlobalNav2.styles.childrenContainer, ";");

var WithGlobalNav = function WithGlobalNav(_ref) {
  var isLeftSidebarCollapsed = _ref.isLeftSidebarCollapsed,
      children = _ref.children,
      topContent = _ref.topContent,
      leftSidebar = _ref.leftSidebar,
      globalNav = _ref.globalNav;
  return (0, _jsxRuntime.jsx)(_WithGlobalNav["default"], {
    isLeftSidebarCollapsed: isLeftSidebarCollapsed,
    children: (0, _jsxRuntime.jsxs)("div", {
      css: _WithGlobalNav2.styles.base,
      children: [globalNav, (0, _jsxRuntime.jsxs)("div", {
        css: _WithGlobalNav2.styles.mainAreaContainer,
        children: [topContent, (0, _jsxRuntime.jsxs)("div", {
          css: _WithGlobalNav2.styles.contentContainer,
          className: "global-nav-content-container",
          children: [leftSidebar && (0, _jsxRuntime.jsx)(LeftSidebarContainer, {
            isCollapsed: isLeftSidebarCollapsed,
            children: (0, _jsxRuntime.jsx)("div", {
              css: _WithGlobalNav2.styles.leftSidebarHolder,
              children: leftSidebar
            })
          }), (0, _jsxRuntime.jsx)(ChildrenContainer, {
            isLeftSidebarCollapsed: isLeftSidebarCollapsed,
            className: "global-nav-children-container",
            children: children
          })]
        })]
      })]
    })
  });
};

WithGlobalNav.propTypes = {
  isLeftSidebarCollapsed: _propTypes.bool,
  children: _propTypes.node,
  topContent: _propTypes.node,
  leftSidebar: _propTypes.node,
  globalNav: _propTypes.node
};
WithGlobalNav.defaultProps = {
  isLeftSidebarCollapsed: false,
  children: undefined,
  topContent: undefined,
  leftSidebar: undefined,
  globalNav: undefined
};
var _default = WithGlobalNav;
exports["default"] = _default;
//# sourceMappingURL=WithGlobalNav.js.map